import {useForm, FormProvider} from "react-hook-form";
import * as Yup from 'yup'
import {yupResolver} from '@hookform/resolvers/yup'
import {NumberInput} from "./inputs";


const schema = Yup.object({
  width: Yup.number().default(200).min(80).max(1000).required(),
  height: Yup.number().default(210).min(200).max(1000).required(),
})


export default function ConfigurationForm(props) {
  const formMethods = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: {
      ...schema.getDefault(),
      ...props.dimensions,
    },
  })

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(props.onSubmit)}>
        <div className="row mb-4">
          <div className="col-sm-6">
            <NumberInput name="width" label="Szerokość wnęki" customProps={{type: 'number', min: 90, max: 1000, step: 5}}/>
          </div>
          <div className="col-sm-6">
            <NumberInput name="height" label="Wysokość wnęki" customProps={{type: 'number', min: 200, max: 1000, step: 5}}/>
          </div>
        </div>

        <button className="btn btn-primary w-100">Dalej</button>
      </form>
    </FormProvider>
  )
}
